import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import AnimatedRoutes from './components/AnimatedRoutes/AnimatedRoutes';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import './styles/global.css'
import Inicio from './pages/Inicio/Inicio';
import NossosValores from './pages/NossosValores/NossosValores';
import SobreNos from './pages/SobreNos/SobreNos';
import Solucoes from './pages/Solucoes/Solucoes';
import Contato from './pages/Contato/Contato';
import SobreAEmpresa from './pages/SobreAEmpresa/SobreAEmpresa';
import Simao from './pages/Simao/Simao';
import Elohim from './pages/Elohim/Elohim';
import Sanarix from './pages/Sanarix/Sanarix';
import NotaFiscal from './pages/NotaFiscal/NotaFiscal';
import TIPresencial from './pages/TIPresencial/TIPresencial';

function RouteObserver({ setActiveMenu }) {
  const location = useLocation();
  
  useEffect(() => {
    const content = document.querySelector('.content');
    if (content) content.scrollTo({ top: 0, behavior: 'smooth' });

    const currentPath = location.pathname.slice(1) || "Inicio";

    const solutionPages = ['Simao', 'Elohim', 'Sanarix', 'NotaFiscal', 'TIPresencial', 'SistemasPersonalizados', 'ConsultoriaTI', 'SuporteTecnico', 'CloudSolutions'];

    if (solutionPages.includes(currentPath)) {
      setActiveMenu("NossasSolucoes");
    } else {
      setActiveMenu(currentPath);
    }
  }, [location, setActiveMenu]);
  
  return null;
}

function AnimatedRoutesWrapper({ setActiveMenu }) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<AnimatedRoutes><Inicio setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/NossosValores" element={<AnimatedRoutes><NossosValores setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/SobreNos" element={<AnimatedRoutes><SobreNos setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/Servicos" element={<AnimatedRoutes><Solucoes setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/Contato" element={<AnimatedRoutes><Contato setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/SobreAEmpresa" element={<AnimatedRoutes><SobreAEmpresa setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/Simao" element={<AnimatedRoutes><Simao setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/Elohim" element={<AnimatedRoutes><Elohim setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/Sanarix" element={<AnimatedRoutes><Sanarix setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/NotaFiscal" element={<AnimatedRoutes><NotaFiscal setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
        <Route path="/TIPresencial" element={<AnimatedRoutes><TIPresencial setActiveMenu={setActiveMenu} /></AnimatedRoutes>} />
      </Routes>
    </AnimatePresence>
  );
}

function RoutesApp() {
  const [activeMenu, setActiveMenu] = useState("");

  return (
    <BrowserRouter>
      <Header activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
      <RouteObserver setActiveMenu={setActiveMenu} />
      <WhatsAppButton />
      <main className="content">
        <div className="content-inner">
          <div className="page-wrapper">
            <AnimatedRoutesWrapper setActiveMenu={setActiveMenu} />
          </div>
          <Footer/>
        </div>
      </main>
    </BrowserRouter>
  );
}

export default RoutesApp;